import dayjs from "dayjs";
import { constStr, exportDMFormat, rnLedActions } from "../../../globals/constants";
import { InitialStateTask } from "./types";

export const initialState: InitialStateTask = {
  scheduledtask: {
    taskName: { title: "", value: "" },
    deviceName: [],
    name: "",
    description: "",
    scheduleOnce: "0",
    nextTime: dayjs().add(1, "minute").valueOf(), //start At, //start At
    period: "0", //Repeats
    className: "",
    encryptPasswords: false,
    tasksMaxConcurrentDevices: "50", //max Simultaneous Devices
    setParameter: false,
    parentTask: "None", // Dependency task
    taskProperties: {},
    idType: "LED Operations",
    protocol: "scp",
    serverType: "Task Specific",
    softwareUpdateClean: "None",
    port: 22,
    sshOperation: false,
    generateFileName: false,
    outputFormat: exportDMFormat[0].value,
    outputDirectory: constStr.taskBackupLocation,
    customReportInputMode: "TEMPLATE",
    manualAttributes: "",
    dbCloneSupported: true,

    cellIdSet: false,
    zoneIdSet: false,
    allCell: true,
    cellIdValue: "",
    zoneIdValue: "",
    setDebug: "",
    setDebugRows: [],
    radiounitLogRequest: "RU_LOG_START",
    lteRnLocationRequest: constStr.checkLocation,
    isAll: false,
    lteSelfConfigType: constStr.neighborList,
    zoneRemValue: "",
    txPowerType: "Max Power",
    nodeFileMgmt: [],
    nodeFileMgmtAllInString: "",
    actionName: rnLedActions[0],
    fileName: "",
    prefixFileName: "",
    trapName: "EranNotifTest",
    trapTarget: 0,
    trapSeverity: "Clear",
    referenceSinglePowerEnabled: "false",
    auditReportType: "None",
    reportFileName: "",
    emailGroupName: "",
    siteGroupList: [],
    regionList: []
  },
  activeTaskStep: 0,
  isEditTask: false,
  selectedTemplate: "",
};
